import {
  InputBaseProps as MantineInputBaseProps,
  InputBase as MantineInputBase,
} from '@mantine/core';

export type InputBaseProps = MantineInputBaseProps;

export const InputBase = MantineInputBase as typeof MantineInputBase;

InputBase.displayName = 'InputBase';
